import { cn } from '@mntn-dev/ui-utilities'
import type { CSSProperties } from 'react'
import { Skeleton } from './skeleton.tsx'
import { type SkeletonHeadingSize, skeletonFontSizeMap } from './types.ts'

type SkeletonHeadingProps = {
  className?: string
  headingSize?: SkeletonHeadingSize
  style?: CSSProperties
}

const SkeletonHeading = ({
  className,
  headingSize = 'xl',
  style,
}: SkeletonHeadingProps) => {
  return (
    <Skeleton
      className={cn(
        'w-full rounded-lg',
        skeletonFontSizeMap[headingSize],
        className
      )}
      style={style}
    />
  )
}

export { SkeletonHeading, type SkeletonHeadingProps }
